async function fetchData(rec_product) {
  try {
    const response = await fetch(
      `https://www.fuehlmaeuse.de/recommendations/products.json?product_id=${rec_product}&limit=2`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const json = await response.json();

    return json;
  } catch (error) {
    console.error('An error occurred:', error);
    throw error; // You can choose to handle or rethrow the error as needed
  }
}
// Call the fetchData function and handle the response
fetchData(rec_product)
  .then((data) => {
    // Handle the data based on the structure of the API response
    console.log('Data:', data);
  })
  .catch((error) => {
    console.error('Error:', error);
    // Handle the error here
  });
